import { Container, Grid } from '@material-ui/core'
import React from 'react'
import ServiceCard from './sub_widgets/ServiceCard'


function Mini({ minis}) {
    return (
        <Container maxWidth="lg" className="section-padding-t">
            <Grid container spacing={2}>
                {minis.map((mini)=>(
                    <Grid item key={mini.id} lg={3} md={3} sm={6} xs={12}>
                        <ServiceCard image={mini.image} title={mini.heading} subTitle={mini.text}/>
                    </Grid>
                ))}
            </Grid>
        </Container>
    )
}

export default Mini
